module.exports = "https://www.gc-pro.gnp.com.mx/aa9bc4ea227b53b132a3cab6dcca4d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-add.png
// module id = 8118
// module chunks = 0